import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/v2/ui/button";
import {
  Sheet as Drawer,
  SheetClose as DrawerClose,
  SheetContent as DrawerContent,
  SheetFooter as DrawerFooter,
  SheetHeader as DrawerHeader,
  SheetTitle as DrawerTitle,
  SheetTrigger as DrawerTrigger,
} from "@/components/v2/ui/sheet";
import FilterSidebar from "./FilterSidebar";

const FilterDrawer = (props) => {
  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2 border-primary/20">
          <SlidersHorizontal className="h-4 w-4" />
          Filters
          {props.activeFilterCount > 0 && (
            <span className="bg-primary text-primary-foreground text-xs rounded-full h-5 w-5 flex items-center justify-center">
              {props.activeFilterCount}
            </span>
          )}
        </Button>
      </DrawerTrigger>
      <DrawerContent side="left">
        <DrawerHeader>
          <DrawerTitle>Filters</DrawerTitle>
        </DrawerHeader>
        <div className="px-4 pb-4 max-h-[80vh] overflow-y-auto">
          <FilterSidebar
            categories={props.categories}
            selectedCategories={props.selectedCategories}
            onCategoryToggle={props.onCategoryToggle}
            priceRange={props.priceRange}
            onPriceChange={props.onPriceChange}
            selectedDurations={props.selectedDurations}
            onDurationToggle={props.onDurationToggle}
            onClearAll={props.onClearAll}
          />
        </div>
        <DrawerFooter>
          <DrawerClose asChild>
            <Button className="w-full">Show Results</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default FilterDrawer;
